module.exports = "/_next/static/images/sk-8fff59a65cb2a7bd6a64ae0172184119.svg";